import { ReactNode } from 'react';

import { StepFour } from '../components/forms/add-template/steps/step-four';
import { StepOne } from '../components/forms/add-template/steps/step-one';
import { StepThree } from '../components/forms/add-template/steps/step-three';
import { StepTwo } from '../components/forms/add-template/steps/step-two';
import { StepContentProps } from '../types/template.types';

export const stepContentByStep: Record<number, (props: StepContentProps) => ReactNode> = {
  1: (props) => <StepOne {...props} />,
  2: (props) => <StepTwo {...props} />,
  3: (props) => <StepThree {...props} />,
  4: (props) => <StepFour {...props} />,
};
